export default __webpack_public_path__ + "static/Poppins-BoldItalic-7d7a881a152aa2ca771584b752412451.woff2";